import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ShellComponent } from './shell/shell.component';

@Component({
  selector: 'app-layout',
  imports: [ShellComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './layout.component.html',
})
export class LayoutComponent {}
